import { render, staticRenderFns } from "./ot-tag-wrapper.vue?vue&type=template&id=1f0d4e47&scoped=true&"
import script from "./ot-tag-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-tag-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-tag-wrapper.vue?vue&type=style&index=0&id=1f0d4e47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0d4e47",
  null
  
)

export default component.exports